






































import { Vue, Component, Inject, Prop, Watch } from "vue-property-decorator";

// Enums/Data
import { QUERY_PARAMS } from "@/data/constants";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";
import { IBasketRoute } from "@/models/baskets";
import { ICurrency } from "@/models/constants";

@Component
export default class BasketCurrencySwitcher extends Vue {
  // Inject
  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  // Props
  @Prop({ default: () => [] })
  public basketRoutes!: IBasketRoute[];

  // Data
  public currencyCode = this.basketData.currencyCode;

  // Computed
  public get basketData() {
    return this.$basketData();
  }

  public get isProcessing() {
    return this.basketData.currencyIsSwitching || this.basketData.isProcessing;
  }

  public get triggerEvents() {
    return {
      click: $e => {
        if (this.isProcessing) $e.stopPropagation();
      }
    };
  }

  public get currentCurrency() {
    return (
      this.$_.find(this.basketData.supportedCurrencies, [
        "code",
        this.currencyCode
      ]) || this.$_.get(this.basketData, "basket.currency")
    );
  }

  public get pathCurrencyCode() {
    return this.$_.get(this.$route.query, QUERY_PARAMS.CURRENCY_CODE, "")
      .toString()
      .toUpperCase() as ICurrency["code"];
  }

  public currencyIsDisabled(currencyCode) {
    return (
      currencyCode === this.pathCurrencyCode ||
      currencyCode === this.$_.get(this.currentCurrency, "code")
    );
  }

  @Watch("basketData.currencyCode")
  onCurrencyChange() {
    this.currencyCode = this.basketData.currencyCode;
  }
}
